var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLearningsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.05 8.7L17.2333 12.1833C16.5333 15.1917 15.15 16.4083 12.55 16.1583C12.1333 16.125 11.6833 16.05 11.2 15.9333L9.79999 15.6C6.32499 14.775 5.24999 13.0583 6.06665 9.575L6.88332 6.08334C7.04999 5.375 7.24999 4.75833 7.49999 4.25C8.47499 2.23333 10.1333 1.69167 12.9167 2.35L14.3083 2.675C17.8 3.49167 18.8667 5.21667 18.05 8.7Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.55 16.1583C12.0333 16.5083 11.3833 16.8 10.5916 17.0583L9.27498 17.4917C5.96665 18.5583 4.22498 17.6667 3.14998 14.3583L2.08331 11.0667C1.01665 7.75833 1.89998 6.00833 5.20831 4.94167L6.52498 4.50833C6.86665 4.4 7.19165 4.30833 7.49998 4.25C7.24998 4.75833 7.04998 5.375 6.88331 6.08333L6.06665 9.575C5.24998 13.0583 6.32498 14.775 9.79998 15.6L11.2 15.9333C11.6833 16.05 12.1333 16.125 12.55 16.1583Z",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5333 7.10834L14.575 8.13334",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.71667 10.3333L12.1333 10.95",
    stroke: "#ADB4BF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLearningsIcon);
export default __webpack_public_path__ + "static/media/My-Learnings-icon.c9d957197d767a87b6cd6d4462cdc9e7.svg";
export { ForwardRef as ReactComponent };